import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicLayoutComponent } from './layout/publicLayout.component';
import { LoginComponent } from './login/login.component';
import { VerifyComponent } from './login/verify/verify.component';

const publicRoutes: Routes = [
{
        path: '',
//        redirectTo: '/login',
        pathMatch: 'full',
        component: PublicLayoutComponent,
        children: [
            {path: '', component: LoginComponent}]        
},
{
    path: 'login',
    component: PublicLayoutComponent,
    children: [
        {path: '', component: LoginComponent}]
},
{
    path: 'login/verify',
    component: PublicLayoutComponent,
    children: [
        {path: '', component: VerifyComponent}]
}];

@NgModule({
    imports: [RouterModule.forChild(publicRoutes)],
    exports: [RouterModule]
})
export class PublicRoutingModule { }
